import api from '../../utils/api';
import store from '../index';
import authStore from './auth';

const state = {
	loanLimit: null,
	paymentBreakdown: null,
	termsAndCondition: null,
	transaction: null,
	transactionStatus: null,
	isCompleted: null,
	partners: null,
	insurers: null,
	isVeendNewUser: null,
	selectedInsurer: null,
	signUpVeendNewUserPayload: null
};

const getters = {
	getTransaction: (state) => state.transaction
};

const actions = {
	async veendFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.get(`${data.api.replace(/^\//, '')}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async veendPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.post(`${data.api.replace(/^\//, '')}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (!store.state.userPartnerToken) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				if (response.next_step.name === 'LOAN_STATUS') {
					commit('setTransactionReference', response.data.reference);
				}
				commit('addPreviousModal', store.state.nextModal);

				commit('setNextModal', response.next_step);
				if (response?.name === 'CHECKING_LOAN_STATUS') {
					commit('setNextModal', response);
				}

				if (response?.next_step?.name === 'AWAITING_REVIEW') {
					commit('setIframeResponseOnSuccess', {
						status: true,
						type: 'SUCCESS',
						data: {
							status: 'successful',
							data: {
								reference: response.data.reference,
								redirect_url: authStore.state.payload.redirect_url
									? authStore.state.payload.redirect_url
									: false
							}
						}
					});
				} else {
					commit('setIframeResponseOnError', {
						message: response.message,
						type: 'ERROR'
					});
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions,
	state,
	getters
};
